import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "./Login.css";
import { BASE_URL } from "./Config";
import Cookies from "js-cookie";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaEye, FaEyeSlash } from "react-icons/fa";

import { useNavigate } from "react-router-dom";
export default function ProductLogin() {
  const [email, setloginEmail] = useState("");
  const [password, setloginpass] = useState("");
  const [toastMessage, setToastMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [alert, setalert] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      setToastMessage("Please fill in all fields.");
      return;
    }

    setLoading(true);

    try {
      const res = await axios.post(`${BASE_URL}/user_login.php?type=login`, {
        login: email,
        password,
      });
      console.log(res);

      if (res.data.success) {
        toast.success("Login Successfully!");

        // ✅ Set cookies
        Cookies.set("user_id", res.data.user_id);
        Cookies.set("username", res.data.name);
        Cookies.set("token", res.data.token);

        // ✅ Redirect or show welcome
        navigate("/list-an-item");
      } else {
        setToastMessage(res.data.message || "Login failed. Please try again.");
        setalert(false);
      }
    } catch (error) {
      console.error("Login Error:", error.response?.data || error);
      setToastMessage("An error occurred. Please try again.");
      setalert(false);
    }
    setLoading(false);
  };

  // const userId = Cookies.get("user_id");
  // const userName = Cookies.get("username");
  // console.log("User ID:", userId);
  // console.log("User Name:", userName);

  return (
    <div className="container pb-5">
      <div className="row">
        <div className="col-12 pt-5">
          <div className="logo">
            <img src="logo/logo.png" alt="logo" />
          </div>
        </div>

        <div className="col-12 pt-4 alert login_alert">
          {toastMessage && (
            <div className={`${alert ? "success" : "failed"} text-center`}>
              {toastMessage}
            </div>
          )}

          <div className="login-form">
            <form onSubmit={handleLogin}>
              <div className="form-page">
                <h2>Login</h2>
                <p>
                  New to Fast Trade?{" "}
                  <Link
                    to="/register-number"
                    className="redirect_link"
                    style={{ fontWeight: "600" }}
                  >
                    Register Now!
                  </Link>
                </p>

                <div className="inputs pt-3">
                  <input
                    type="text"
                    placeholder="Username/Email"
                    className=" mb-3 number_input"
                    style={{ outline: "none" }}
                    value={email}
                    onChange={(e) => setloginEmail(e.target.value)}
                  />

                  <div style={{ position: "relative" }}>
                    <input
                      type={showPassword ? "text" : "password"}
                      placeholder="Enter Password"
                      className="number_input"
                      value={password}
                      onChange={(e) => setloginpass(e.target.value)}
                    />
                    <span
                      onClick={() => setShowPassword(!showPassword)}
                      style={{
                        position: "absolute",
                        right: "15px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        color: "#555",
                      }}
                    >
                      {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </span>
                  </div>
                </div>

                <div className="forget-pass-link pt-3">
                  <Link to="/forget-pass">Forgotten password?</Link>
                </div>

                <div className="submit-btn pt-3">
                  <input
                    type="submit"
                    value={loading ? "Logging in..." : "Login"}
                    className="btn btn-primary"
                    style={{
                      width: "100%",
                      backgroundColor: "#128DE5",
                      padding: "10px",
                      marginBottom: "15px",
                      fontWeight: "600",
                    }}
                    disabled={loading}
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
}
